import React from "react";
import { NavLink } from "react-router-dom";
import { Home as HomeIcon, Compass, Clock, Activity, Settings as SettingsIcon } from "lucide-react";
import { useApp } from "@/lib/store";

const items = [
  { to: "/home", label: "Home", icon: HomeIcon, testid: "nav-home" },
  { to: "/navigate", label: "Navigate", icon: Compass, testid: "nav-navigate" },
  { to: "/history", label: "History", icon: Clock, testid: "nav-history" },
  { to: "/pattern", label: "Pattern", icon: Activity, testid: "nav-pattern" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
];

export default function BottomNav() {
  const { focusMode } = useApp();
  if (focusMode) return null;
  return (
    <nav
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-20 bg-[#FDFBF7]/95 backdrop-blur border-t border-[#EBE9E4] pb-safe"
      data-testid="bottom-nav"
    >
      <div className="grid grid-cols-5">
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testid}
            className="flex flex-col items-center justify-center gap-1 py-3 min-h-[56px] ss-focus"
          >
            {({ isActive }) => (
              <>
                <Icon
                  size={20}
                  strokeWidth={1.5}
                  color={isActive ? "#00E5A0" : "#64748B"}
                />
                <span
                  className="text-[11px] tracking-wide"
                  style={{ color: isActive ? "#F8FAFC" : "#64748B", fontWeight: isActive ? 600 : 500 }}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
